import { useAuth } from '../hooks/useAuth'

export default function AccessDenied() {
  const { logout, user } = useAuth()

  return (
    <div className="access-denied-container">
      <div className="access-denied-card">
        <div className="access-denied-icon">
          <svg
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
          </svg>
        </div>
        <h1>Access Denied</h1>
        <p>You don't have access to Jamf Lens.</p>
        <p className="access-denied-contact">Contact your administrator to request access.</p>
        {user?.email && (
          <p className="access-denied-email">Signed in as: {user.email}</p>
        )}
        <button className="btn btn-primary" onClick={() => logout()}>
          Sign Out
        </button>
      </div>
    </div>
  )
}
